import { CheckboxGroupOption } from "../../Unknown/CheckboxGroup";

type AddOn = {
  id: string;
  name: string;
  price: number;
  allowMultiplePurchases?: boolean;
};

const parseAddOnToCheckboxGroupOption = ({
  addOn,
  currencyCode,
  checked,
  quantity,
  onQuantityChange,
}: {
  addOn: AddOn;
  currencyCode: string;
  checked: boolean;
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
}): CheckboxGroupOption => {
  const { id, name, price, allowMultiplePurchases } = addOn;
  return {
    value: id,
    label: name,
    price,
    currencyCode,
    checked,
    allowMultiplePurchases,
    quantity,
    onQuantityChange,
  };
};

export default parseAddOnToCheckboxGroupOption;
